import HTTP from "../../utility/http";
import { asyncHandler } from "@/utility/async";

const actions = {
  async search(context, data) {
    return await asyncHandler(
      HTTP({
        url: "album/search",
        method: "POST",
        data,
      })
    );
  },
  async delete(context, id) {
    return await asyncHandler(
      HTTP({
        url: "album/delete/" + id,
        method: "GET",
      })
    );
  },
};

export default {
  namespaced: true,
  actions,
};
